import { render, staticRenderFns } from "./widget-rich-text.vue?vue&type=template&id=d69c43c4&scoped=true"
import script from "./widget-rich-text.vue?vue&type=script&lang=js"
export * from "./widget-rich-text.vue?vue&type=script&lang=js"
import style0 from "./widget-rich-text.vue?vue&type=style&index=0&id=d69c43c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69c43c4",
  null
  
)

export default component.exports